import { init } from "../init-streaming";
import { JiraProductDiscoveryPage } from "../pages/software/jira/product-discovery/jira-product-discovery-page";

init(JiraProductDiscoveryPage);
